import { getRawOuterUrl } from '../rich-content/services/get-outer-url';
export var numberToPage = function (page) { return (page > 1 ? "/page/" + page + "/" : '/'); };
export var createPageUrl = function (page, sectionUrl) { return getRawOuterUrl(numberToPage(page), sectionUrl).toString(); };
